import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { cn } from '../../utils/cn';
interface AccordionItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onClick: () => void;
}
function AccordionItem({
  question,
  answer,
  isOpen,
  onClick
}: AccordionItemProps) {
  return <div className="border-b border-beige last:border-0" data-id="element-295">
      <button className="w-full py-6 flex items-center justify-between text-left focus:outline-none group" onClick={onClick} aria-expanded={isOpen} data-id="element-296">
        <span className="font-heading text-xl font-medium text-taupe group-hover:text-gold transition-colors pr-4" data-id="element-297">
          {question}
        </span>
        <ChevronDownIcon className={cn('w-5 h-5 text-gold flex-shrink-0 transition-transform duration-300', isOpen ? 'transform rotate-180' : '')} data-id="element-298" />
      </button>
      <div className={cn('overflow-hidden transition-all duration-300 ease-in-out', isOpen ? 'max-h-96 opacity-100 pb-6' : 'max-h-0 opacity-0')} data-id="element-299">
        <p className="text-taupe-light leading-relaxed font-body" data-id="element-300">{answer}</p>
      </div>
    </div>;
}
interface AccordionProps {
  items: {
    question: string;
    answer: string;
  }[];
  className?: string;
}
export function Accordion({
  items,
  className
}: AccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <div className={cn('bg-cream rounded-2xl p-6 md:p-8 shadow-soft', className)} data-id="element-301">
      {items.map((item, index) => <AccordionItem key={index} question={item.question} answer={item.answer} isOpen={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-302" />)}
    </div>;
}